import { css } from '@emotion/react';

export const EmotionScores = [0, 1, 2, 3, 4] as const;

export type EmotionScore = (typeof EmotionScores)[number];

const LEGACY_COLORS = {
  tangerine: '#F39C11',
  crimson: '#EA4031',
  black_500: '#929292',
  kelly: '#07875A',
  kelly_dark: '#067951',
};

export const EMOTION_COLORS = [
  LEGACY_COLORS.crimson,
  LEGACY_COLORS.tangerine,
  LEGACY_COLORS.black_500,
  LEGACY_COLORS.kelly,
  LEGACY_COLORS.kelly_dark,
];

export function getIconColor(score: EmotionScore): string {
  return EMOTION_COLORS[score] ?? '';
}

export const iconSizeMap = {
  xs: 12,
  s: 18,
  m: 24,
  l: 40,
} as const;

export type IconSize = keyof typeof iconSizeMap;

export const iconBaseStyles = css`
  display: inline-block;
  vertical-align: middle;
`;
